import { mapGetters } from 'vuex';
import pluginMixin from './pluginMixin';
import Measurements, { MeasurementSystems } from '@/types/measurements';

export default {
  mixins: [
    pluginMixin,
  ],
  components: {},
  computed: {
    ...mapGetters('profiles', {
      isLtnAdmin: 'isLtnAdmin',
    }),
    siteDistanceMeasurePerLabel() {
      return this.$t(`units-of-measure.distance.per.${this.unitsOfMeasure}`)
    },
    siteDistanceMeasureUnitsLabel() {
      return this.$t(`units-of-measure.distance.units.${this.unitsOfMeasure}`)
    },
    siteDistanceMeasureUnitLabel() {
      return this.$t(`units-of-measure.distance.unit.${this.unitsOfMeasure}`)
    },
    siteWeightMeasureLabel() {
      return this.$t(`units-of-measure.weight.units.${this.unitsOfMeasure}`)
    },
  },
  methods: {
    kgAsPounds(kg) {
      return Measurements.KgToPounds(kg);
    },
    kmAsMiles(km) {
      return Measurements.KmToMiles(km);
    },
    milesAsKm(miles) {
      return Measurements.MilesToKm(miles);
    },
    milesToDistanceUnitOfMeasure(miles) {
      let adjusted = miles;
      if (this.unitsOfMeasure === MeasurementSystems.METRIC) {
        adjusted = this.milesAsKm(miles).toFixed(0);
      }

      return adjusted;
    },
    normalizeDistanceUnitOfMeasureToMiles(distance) {
      let normalized = distance;
      if (this.unitsOfMeasure === MeasurementSystems.METRIC) {
        normalized = this.kmAsMiles(distance).toFixed(0);
      }

      return normalized;
    },
    distanceLabel(distance) {
      const adjusted = this.milesToDistanceUnitOfMeasure(distance);
      const unit = this.siteDistanceMeasureUnitsLabel;

      return `${adjusted} ${unit}`;
    },
    distanceRate(amount, distance) {
      const adjusted = this.milesToDistanceUnitOfMeasure(distance);

      return (amount / adjusted).toFixed(2);
    },
    distanceDurationHours(distance) {
      return (this.normalizeDistanceUnitOfMeasureToMiles(distance) / 55).toFixed(1);
    },
    distanceRateLabel(amount, distance) {
      const rate = this.distanceRate(amount, distance);
      const unit = this.siteDistanceMeasurePerLabel;

      return `${rate}/${unit}`;
    },
  },
  filters: {
    normalizeDistance(distance) {
      return this.milesToDistanceUnitOfMeasure(distance);
    }
  },
}



// WEBPACK FOOTER //
// ./src/mixins/unitsOfMeasurePlugin.js